import React, { Component } from 'react';
import { Elements } from 'react-stripe-elements';

import NewCardForm from './NewCardForm';

import './style.css';

class PaymentFailure extends Component {
  render() {
    return (
      <div className="PaymentFailure text-center mx-auto mb-5">
        <h4>There&#39;s an issue with your billing</h4>
        <p className="my-3">
          It looks like your previous payment didn&#39;t go through.<br />
          You&#39;ll need to add funds to your existing card on file or update your billing information
          before you resume your membership with Rype.
        </p>
        <Elements>
          <NewCardForm />
        </Elements>
      </div>
    );
  }
}

export default PaymentFailure;



// WEBPACK FOOTER //
// ./src/pages/student/PaymentFailure/index.js